import {
    safeSendersTitle,
    safeSendersSubtext,
} from './addMailboxToSafeSenderListOrchestrator.locstring.json';
import loc, { format } from 'owa-localize';
import getMailboxJunkEmailConfiguration from '../services/getMailboxJunkEmailConfiguration';
import setMailboxJunkEmailConfiguration from '../services/setMailboxJunkEmailConfiguration';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { lazyAddToSpamList, SpamScenarioId } from 'owa-spam-row-option';

import { orchestrator } from 'satcheljs';
import {
    addMailboxToSafeSenders,
    addMailboxToTrustedSendersList,
} from '../actions/actionCreators/addToSafeSenders';

/**
 * Fetches the junkEmailConfiguration, adds the mailbox to the end of trustedSendersAndDomains, and updates
 * the userConfiguration option locally and on the server
 */
orchestrator(addMailboxToSafeSenders, async actionMessage => {
    const confirmResponse = await confirm(
        format(loc(safeSendersTitle), actionMessage.mailbox.EmailAddress),
        format(loc(safeSendersSubtext), actionMessage.mailbox.EmailAddress)
    );
    if (confirmResponse === DialogResponse.ok) {
        const junkMailConfiguration = await getMailboxJunkEmailConfiguration();

        addMailboxToTrustedSendersList(actionMessage.mailbox, junkMailConfiguration);
        setMailboxJunkEmailConfiguration(junkMailConfiguration);

        lazyAddToSpamList.importAndExecute(
            SpamScenarioId.SafeSendersAndDomains,
            actionMessage.mailbox.EmailAddress,
            -1
        );
    }
});
